'use strict';

var doingFilter = false;

var jqxhr;
var filter = {
	$this: $('.js-filter'),
	$listing: $('.listing'),
	$loader: $('.filter-loader'),
	setScrollTop: 0
};

var updateListingItems = function updateListingItems(page) {

	var thema = $('.js-row-thema .is-active').data('value');
	var type = $('.js-row-type .is-active').data('value');
	$('.js-no-results').fadeOut();
	if (page === 1) {
		//clears the page if not loading second page
		$('.page-inner .listing').html('');
		// Shows loader if not loading more items (i.e. first page), then gets items
		filter.$listing.fadeOut(100, function () {
			filter.$loader.fadeIn(100, function () {
				ajaxGetItems(thema, type, page);
			});
		});
	} else {
		//get items without showing the loader
		ajaxGetItems(thema, type, page);
	}
	$('.page-inner .listing').icons.init('.svg-icon');
};

var ajaxGetItems = function ajaxGetItems(thema, type, page) {
	doingFilter = true;
	jqxhr = $.ajax({
		url: customData.ajaxURL,
		dataType: 'json',
		data: {
			action: 'load_filtered_items',
			publicatie_type: type,
			taxonomy: thema,
			page: page
		}
	}).done(function (data) {
		doingFilter = false;
		$('.show-more[data-action="publicaties"]').show();
		if (data.html) {
			$('.page-inner .listing').append(data.html);
			$('.show-more[data-action="publicaties"]').data('page', data.nextPage);
			if (data.items < customData.itemsPerPage) {
				$('.show-more[data-action="publicaties"]').hide();
			}
		} else {
			$('.show-more[data-action="publicaties"]').hide();
			$('.js-no-results').fadeIn();
		}
		filter.$loader.fadeOut(100, function () {
			filter.$listing.fadeIn();
			$('.page-inner .listing').icons.init('.svg-icon');
			$('.init').imageLoader({
				ready: function ready(prop) {
					//console.log(prop);
				},
				resize: function resize(prop) {
					//console.log('resize');
					//alert('resize');
				}
			});
		});
	});
};

var activateItem = function activateItem($item) {
	if (doingFilter == true) {
		jqxhr.abort();
	}
	doingFilter = false;
	if ($item.hasClass('is-active')) {
		$item.removeClass('is-active');
	} else {
		$item.addClass('is-active').siblings('.js-filter-item').removeClass('is-active');
		// updateListingItems(1);
	}
	$('.js-reset-filter').addClass('is-shown');
	updateListingItems(1);
};

filter.init = function () {

	//console.log('init');
	$('.show-more[data-action="publicaties"]').click(function (e) {
		e.preventDefault();
		var page = $(this).data('page');
		updateListingItems(page);
	});
	$('.js-filter-item').on('click', function (e) {
		e.preventDefault();
		e.stopPropagation();
		activateItem($(this));
	});

	$('.js-reset-filter').click(function (e) {
		// e.preventDefault();
		$('.is-active').each(function () {
			$(this).removeClass('is-active');
		});
		updateListingItems(1);
		$(this).removeClass('is-shown');
		// $( this ).hide();
	});
};